import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ed69542")

_pushScopeId("data-v-5ed69542")
const _hoisted_1 = { class: "mr-1 md:ml-2 md:m-0 relative" }
const _hoisted_2 = { class: "sr-only" }
const _hoisted_3 = {
  key: 0,
  class: "rounded-full border-2 flex relative"
}
const _hoisted_4 = { class: "h-8 w-8 rounded-full text-gray-50 flex items-center justify-center" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "px-4 py-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, " Signed in as ", -1)
const _hoisted_8 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_9 = { class: "py-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")
  const _component_MenuButton = _resolveComponent("MenuButton")
  const _component_MenuItem = _resolveComponent("MenuItem")
  const _component_MenuItems = _resolveComponent("MenuItems")
  const _component_Menu = _resolveComponent("Menu")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_Menu, {
      as: "div",
      class: "fixed inline-block text-left flex-shrink-0",
      style: {"z-index":"999999","margin-top":"-19px"}
    }, {
      default: _withId(() => [
        _createVNode("div", null, [
          _createVNode(_component_MenuButton, { class: "bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white" }, {
            default: _withId(() => [
              _createVNode("div", null, [
                _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("nav.Header.userMenu")), 1),
                (!_ctx.getUserImage || _ctx.getUserImage.toString().length === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_ctx.getUserInitials) + " ", 1),
                        _createVNode(_component_ChevronDownIcon, {
                          "aria-hidden": "true",
                          class: "-mr-1 ml-2 h-5 w-5",
                          style: {"color":"white","margin":"auto"}
                        })
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode("img", {
                        src: _ctx.getUserImage,
                        title: _ctx.getFullName,
                        alt: "",
                        class: "h-8 w-8 rounded-full"
                      }, null, 8, ["src", "title"]),
                      _createVNode(_component_ChevronDownIcon, {
                        "aria-hidden": "true",
                        class: "-mr-1 ml-2 h-5 w-5",
                        style: {"color":"white","margin":"auto"}
                      })
                    ]))
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: _withId(() => [
            _createVNode(_component_MenuItems, { class: "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("p", _hoisted_8, _toDisplayString(_ctx.getFullName), 1)
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_MenuItem, null, {
                    default: _withId(({ active }) => [
                      _createVNode("button", {
                        class: [active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full text-left px-4 py-2 text-sm'],
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                      }, " Sign out ", 2)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, true]
    ])
  ], 512)), [
    [_vShow, _ctx.isAuthenticated]
  ])
})